export interface EditMenuRedux {
  menu_id:number;
  name: string
  description: string
  category_id: number
  isActive: string
  isAvailable: string
  image?: string
  imageFileId?: string
}



const initialState: EditMenuRedux = {
  menu_id:0,
  name: '',
  description: '',
  category_id: 0,
  isActive: '',
  isAvailable: '',
  image: '',
  imageFileId: ''
};

export type MenuAction =
  | {
      type: "EDITMENU";
      payload: EditMenuRedux;
    }
  | {
      type: "CLEAREDIT";
    };

export const menuReducer = (
  state: EditMenuRedux = initialState,
  action: MenuAction
) => {
  switch (action.type) {
    case "EDITMENU":
      return action.payload;
    case "CLEAREDIT":
      return initialState;
    default:
      return state;
  }
};
